module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background",
    class: {
      'long': _vm.long
    }
  }, [_c('div', {
    staticClass: "chart-container",
    class: {
      'longCont': _vm.long
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.styleText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('EventReport')) + " (" + _vm._s(_vm.$t('By Category')) + ")")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('period')) + ": " + _vm._s(_vm.timeRange))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1"
  }, [_c('tr', [_c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.$t('uername')) + ": " + _vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.$t('fullName')) + ": " + _vm._s(_vm.statics.name))]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')) + ": " + _vm._s(_vm.statics.medical_history))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('HbA1c')) + ": " + _vm._s(_vm.hb1c))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "29px",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('BG Summary')))]), _vm._v(" "), _vm._l((_vm.pagePosBG), function(base, p) {
    return _c('div', [(p >= 1) ? _c('div', [_c('div', {
      staticClass: "page-break"
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "events-table",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "id": "bg" + base
      }
    }, [_c('tr', [_c('td', {
      staticClass: "td5",
      attrs: {
        "width": "95px"
      }
    }, [_vm._v(_vm._s(_vm.$t('date')))]), _vm._v(" "), _vm._l((_vm.hours), function(i) {
      return _c('td', {
        staticClass: "td2"
      }, [_vm._v(_vm._s(i))])
    }), _c('td', {
      staticClass: "td5"
    }, [_vm._v("Avg/#")])], 2), _vm._v(" "), _vm._l((_vm.whichDate.slice(base, base + base + _vm.perPageBG[p])), function(day) {
      return _c('tr', [_c('td', {
        staticClass: "td1 td4"
      }, [_vm._v(_vm._s(day))]), _vm._v(" "), _vm._l((24), function(i) {
        return _c('td', {
          staticClass: "td4"
        })
      }), _c('td', {
        staticClass: "td1 td2"
      })], 2)
    })], 2)])
  }), _vm._v(" "), (_vm.endPageBG.show) ? _c('div', [_c('div', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "29px",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Carbs Summary')))]), _vm._v(" "), _vm._l((_vm.pagePosCarb), function(base, p) {
    return _c('div', [(p >= 1) ? _c('div', [_c('div', {
      staticClass: "page-break"
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "events-table",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "id": "carb" + base
      }
    }, [_c('tr', [_c('td', {
      staticClass: "td5",
      attrs: {
        "width": "95px"
      }
    }, [_vm._v(_vm._s(_vm.$t('date')))]), _vm._v(" "), _vm._l((_vm.hours), function(i) {
      return _c('td', {
        staticClass: "td2"
      }, [_vm._v(_vm._s(i))])
    }), _c('td', {
      staticClass: "td5"
    }, [_vm._v("Avg/#")])], 2), _vm._v(" "), _vm._l((_vm.whichDate.slice(base, base + _vm.perPageCarb[p])), function(day) {
      return _c('tr', [_c('td', {
        staticClass: "td1 td4"
      }, [_vm._v(_vm._s(day))]), _vm._v(" "), _vm._l((24), function(i) {
        return _c('td', {
          staticClass: "td4"
        })
      }), _c('td', {
        staticClass: "td1 td2"
      })], 2)
    })], 2)])
  }), _vm._v(" "), (_vm.endPageCarb.show) ? _c('div', [_c('div', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "29px",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Injection Summary')))]), _vm._v(" "), _vm._l((_vm.pagePosInj), function(base, p) {
    return _c('div', [(p >= 1) ? _c('div', [_c('div', {
      staticClass: "page-break"
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "events-table",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "id": "bol" + base
      }
    }, [_c('tr', [_c('td', {
      staticClass: "td5",
      attrs: {
        "width": "95px"
      }
    }, [_vm._v(_vm._s(_vm.$t('date')))]), _vm._v(" "), _vm._l((_vm.hours), function(i) {
      return _c('td', {
        staticClass: "td2"
      }, [_vm._v(_vm._s(i))])
    }), _c('td', {
      staticClass: "td5"
    }, [_vm._v("Avg/#")])], 2), _vm._v(" "), _vm._l((_vm.whichDate.slice(base, base + _vm.perPageInj[p])), function(day) {
      return _c('tr', [_c('td', {
        staticClass: "td1 td4"
      }, [_vm._v(_vm._s(day))]), _vm._v(" "), _vm._l((24), function(i) {
        return _c('td', {
          staticClass: "td4"
        })
      }), _c('td', {
        staticClass: "td1 td2"
      })], 2)
    })], 2)])
  }), _vm._v(" "), (_vm.endPageInj.show) ? _c('div', [_c('div', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "29px",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Exercise Summary')))]), _vm._v(" "), _vm._l((_vm.pagePosExer), function(base, p) {
    return _c('div', [(p >= 1) ? _c('div', [_c('div', {
      staticClass: "page-break"
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "events-table",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "id": "exer" + base
      }
    }, [_c('tr', [_c('td', {
      staticClass: "td5",
      attrs: {
        "width": "95px"
      }
    }, [_vm._v(_vm._s(_vm.$t('date')))]), _vm._v(" "), _vm._l((_vm.hours), function(i) {
      return _c('td', {
        staticClass: "td2"
      }, [_vm._v(_vm._s(i))])
    }), _c('td', {
      staticClass: "td5"
    }, [_vm._v("Avg/#")])], 2), _vm._v(" "), _vm._l((_vm.whichDate.slice(base, base + _vm.perPageExer[p])), function(day) {
      return _c('tr', [_c('td', {
        staticClass: "td1 td4"
      }, [_vm._v(_vm._s(day))]), _vm._v(" "), _vm._l((24), function(i) {
        return _c('td', {
          staticClass: "td4"
        })
      }), _c('td', {
        staticClass: "td1 td2"
      })], 2)
    })], 2)])
  }), _vm._v(" "), (_vm.endPageExer.show) ? _c('div', [_c('div', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('type')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Avg')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('SD')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('max')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('min')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('#')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('BG1')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bgstat[0]))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bgstat[1]))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bgstat[2]))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bgstat[3]))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.bgstat[4]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.carbstat[0]))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.carbstat[1]))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.carbstat[2]))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.carbstat[3]))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.carbstat[4]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Injection')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bolstat[0]))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bolstat[1]))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bolstat[2]))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bolstat[3]))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.bolstat[4]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('exercise')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.exerstat[0]))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.exerstat[1]))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.exerstat[2]))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.exerstat[3]))]), _c('td', [_vm._v(_vm._s(_vm.exerstat[4]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/LOGO.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31b262ad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print-htmplate/quickPrint7.vue
// module id = 1452
// module chunks = 7